import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const efficiencyTrackerState = (state: RootState) => state.scene.dashboard.efficiencyTrackerState;

export const getEfficiencyTrackerDrillDownViewState = createSelector(
  efficiencyTrackerState,
  ({ viewState }) => viewState
);

export const getEfficiencyTrackerDrillDownTotalFilteredRecords = createSelector(
  efficiencyTrackerState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getEfficiencyTrackerDrillDownTotalRecords = createSelector(
  efficiencyTrackerState,
  ({ totalRecords }) => totalRecords
);

export const getEfficiencyTrackerDrillDownCustomDateRange = createSelector(
  efficiencyTrackerState,
  ({ drillDownCustomDateRange }) => drillDownCustomDateRange
);

export const getEfficiencyTrackerDrillDownConfiguration = createSelector(
  efficiencyTrackerState,
  ({ configuration }) => configuration
);

export const getEfficiencyTrackerDrillDownStats = createSelector(
  efficiencyTrackerState,
  ({ stats }) => stats
);

export const isEfficiencyTrackerDrillDownLoading = createSelector(
  efficiencyTrackerState,
  ({ loading }) => loading
);
